/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {useCallback, useState} from 'react';

/**
 * React Hook to provide additional states required in Email Export.
 *
 *  ```typescript
 *   import {useJobSearchEngineExport} from '@ion/ion-ctc-admin/src/routes/provisioning/jobs';
 *
 *   const {
 *     isEmailExportRequest,
 *     setIsEmailExportRequest,
 *     onCloseEmailExportDialog
 *   } = useJobSearchEngineExport();
 *
 *  ```
 */
export const useJobSearchEngineExport = () => {
  const [isEmailExportRequest, setIsEmailExportRequest] = useState(false);

  const onCloseEmailExportDialog = useCallback(() => {
    setIsEmailExportRequest(false);
  }, [isEmailExportRequest]);

  return {
    isEmailExportRequest,
    setIsEmailExportRequest,
    onCloseEmailExportDialog
  };
};

export default useJobSearchEngineExport;
